import { render } from "./DatosMedicos.vue?vue&type=template&id=1c8b0318"
import script from "./DatosMedicos.vue?vue&type=script&lang=js"
export * from "./DatosMedicos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__